import { Boxes, Network, Globe2 } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { wa, WA_MESSAGES } from "@/lib/site";

const CHANNELS = [
  {
    icon: Boxes,
    title: "Wholesale Enquiry",
    text: "Stock MAHIRA in your store or order in bulk for your business.",
    msg: WA_MESSAGES.wholesale,
    testid: "wholesale-enquiry-btn",
  },
  {
    icon: Network,
    title: "Distributor Enquiry",
    text: "Partner with us to bring MAHIRA to your city or region.",
    msg: WA_MESSAGES.distributor,
    testid: "distributor-enquiry-btn",
  },
  {
    icon: Globe2,
    title: "International Enquiry",
    text: "Interested in MAHIRA outside India? Start the conversation.",
    msg: WA_MESSAGES.international,
    testid: "international-enquiry-btn",
  },
];

export default function Wholesale() {
  return (
    <section id="wholesale" data-testid="wholesale-section" className="grain bg-forest py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading dark eyebrow="Business With MAHIRA" title="Partner With MAHIRA">
          Interested in stocking or distributing MAHIRA products? We would love
          to hear from you.
        </SectionHeading>
        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {CHANNELS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="flex h-full flex-col rounded-3xl border border-ivory/15 bg-ivory/5 p-8 backdrop-blur-sm transition-[background-color,border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-gold/50 hover:bg-ivory/10">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold/15 text-gold">
                  <c.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-7 font-heading text-2xl text-ivory">{c.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ivory/65">{c.text}</p>
                <a
                  data-testid={c.testid}
                  href={wa(c.msg)}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-8 inline-flex w-fit items-center rounded-full border border-gold/60 px-7 py-3 text-[11px] font-bold uppercase tracking-[0.2em] text-gold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-forest"
                >
                  {c.title}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
